import { Box, HStack } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import Sidebar from './sidebar/Sidebar';

export const Main = () => {
  return (
    <Box mt="3">
      <HStack align="start">
        <Box flexBasis="22%" h="calc(100vh - .75rem)">
          {/* bg="red" */}
          <Sidebar />
        </Box>
        <Box flexBasis="78%" h="calc(100vh - .75rem)" overflowY="auto">
          <Outlet />
        </Box>
      </HStack>
    </Box>
  );
};
